export interface ApprovalRequest {
    id: string
    status: "Pending" | "Approved" | "Rejected" | "Cancelled"
    cleanerId: string
    cleaningId: string
    unitPrice: number
    createdAt: number
    specialBonus?: number
}

/**
 * 表示上の単価は単価とスペシャルボーナルを合算したものとする
 * 合算して0円の場合はundefinedにする
 */
export const calcTotalUnitPrice = (
    ar?: ApprovalRequest
): number | undefined => {
    const total = (ar?.unitPrice ?? 0) + (ar?.specialBonus ?? 0)
    return total === 0 ? undefined : total
}
